const testKey = 'testStorageAvaiable';
/**
 * localStorage 是否可用
 * @returns
 */
export function localStorageAvaiable() {
    let avaiable = true;
    if (typeof window !== 'undefined') {
        try {
            const storage = window.localStorage;
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
        }
        catch (error) {
            avaiable = false;
        }
        return avaiable;
    }
}
let lastMs = 0;
/**
 * Returns the current unix time in micro-seconds,
 * WARNING: This is a pseudo-function
 * Performance.now is not reliable in webworkers, so we just make sure to never return the same time.
 * This is enough in browsers, and this function will not be used in nodejs.
 * The main reason for this hack is to ensure that BroadcastChannel behaves equal to production when it is used in fast-running unit tests.
 */
export function microSeconds() {
    let ret = Date.now() * 1000; // milliseconds to microseconds
    if (ret <= lastMs) {
        ret = lastMs + 1;
    }
    lastMs = ret;
    return ret;
}
/**
 * 当前时间字符串
 * @returns
 */
export function currentTimeStr() {
    const date = new Date();
    return date.getMinutes() + ':' + date.getSeconds() + '.' + date.getMilliseconds();
}
let isIOS;
/**
 * 是否是 iOS 环境
 * @returns
 */
export function checkIsIOS() {
    if (typeof isIOS === 'undefined') {
        isIOS = /iphone|ipad|ipod|iOS/.test(navigator.userAgent.toLowerCase());
    }
    return isIOS;
}
/**
 * 获取 iOS 系统版本号
 */
export function getIOSVersion() {
    const ua = navigator.userAgent.toLowerCase();
    const regStrSaf = /os [\d._]*/gi;
    const verinfo = ua.match(regStrSaf);
    return (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.') + '';
}
/**
 * 比较版本号
 * @param v1
 * @param v2
 * @returns
 */
export function compareVersion(v1, v2) {
    const arr1 = v1.split('.');
    const arr2 = v2.split('.');
    const len = Math.max(arr1.length, arr2.length);
    while (arr1.length < len) {
        arr1.push('0');
    }
    while (arr2.length < len) {
        arr2.push('0');
    }
    for (let i = 0; i < len; i++) {
        const num1 = parseInt(arr1[i]);
        const num2 = parseInt(arr2[i]);
        if (num1 > num2) {
            return 1;
        }
        else if (num1 < num2) {
            return -1;
        }
    }
    return 0;
}
